// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"101bfb35","135":"996623e7","210":"1938ca7b","378":"d2e456f1","397":"7afbbfb7","566":"8f01e7d0","810":"d73ee0e2","837":"1687e8d1","858":"1b1c3791"}[chunkId] + ".js";
};